// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import initDateHeaders from "./dateHeaders";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();
initDateHeaders();
// Tocbot is initialized in default.hbs after DOM loads